import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap-reboot/reboot.css';

const render = (Component: any) => () => {
  ReactDOM.render(<Component />, document.getElementById('root'));
};

export default render;
